/* Upsell-carrousel in de cart drawer (snippets/cart-upsell.liquid).
   De drawer wordt bij elke cart-update via innerHTML vervangen (cart.js /
   cart-drawer.js); een custom element krijgt dan opnieuw connectedCallback,
   dus de pijltjes werken zonder her-binden. */
if (!customElements.get('cart-upsell')) {
  customElements.define(
    'cart-upsell',
    class CartUpsell extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.mcu__track');
        this.querySelector('.mcu__arrow--prev')?.addEventListener('click', () => this.step(-1));
        this.querySelector('.mcu__arrow--next')?.addEventListener('click', () => this.step(1));
      }

      step(dir) {
        if (!this.track) return;
        const card = this.track.querySelector('.mcu-card');
        const gap = 8;
        const width = card ? card.getBoundingClientRect().width + gap : this.track.clientWidth;
        this.track.scrollBy({ left: dir * width, behavior: 'smooth' });
      }
    }
  );
}

/* checkout_click -> Whop-pixel (komt binnen als pixel.custom:checkout_click)
   met het aantal stuks dat op dat moment in de cart ligt (data-item-count op
   de checkout-knop, ververst bij elke drawer-render).

   Bewust pointerdown en niet click: het Lasso-script vangt click af in de
   capture-fase met stopImmediatePropagation, waardoor click-listeners hier
   nooit draaien. pointerdown raakt Lasso niet aan. Try/catch zodat dit nooit
   de weg naar de checkout kan blokkeren. */
if (!window.__mcCheckoutClickPixelBound) {
  window.__mcCheckoutClickPixelBound = true;
  document.addEventListener(
    'pointerdown',
    (event) => {
      const button = event.target.closest && event.target.closest('#CartDrawer-Checkout');
      if (!button) return;
      try {
        if (window.whop && typeof window.whop.track === 'function') {
          window.whop.track('checkout_click', { count: Number(button.dataset.itemCount || 0) });
        }
      } catch (error) {
        /* nooit de checkout blokkeren */
      }
    },
    true
  );
}
